import React, { useState } from 'react';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <nav className="navbar" id="navbar">
      <div className="nav-brand">
        <img src="/images/logo_testa_cane_fix.gif" alt="Glad Dogs Logo Animato" style={{ height: '130px' }} />
      </div>
      
      <button className="mobile-menu-btn" onClick={toggleMenu}>
        {isMenuOpen ? '✖' : '☰'}
      </button>

      <div className={`nav-menu-container ${isMenuOpen ? 'open' : ''}`}>
        <div className="nav-links">
          <a href="#chi-siamo" onClick={toggleMenu}>Chi siamo</a>
          <a href="#i-nostri-cani" onClick={toggleMenu}>I nostri cani</a>
          <a href="#le-storie" onClick={toggleMenu}>Le loro storie</a>
          <a href="#come-adottare" onClick={toggleMenu}>Come adottare</a>
          <a href="#donazioni" onClick={toggleMenu}>Donazioni</a>
          <a href="#/contatti" onClick={toggleMenu}>Contatti</a>
        </div>
        <div style={{ padding: '0 24px 24px 24px' }} className="nav-cta">
          <button onClick={() => { window.location.hash = '#/volontariato'; toggleMenu(); }} className="btn btn-primary" style={{ width: '100%' }}>
            Diventa Volontario
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
